// extracted by mini-css-extract-plugin
export default {"DesktopMenu":"DesktopMenu_DesktopMenu__NGpLa"};